export enum PostalAreas {
  GET_POSTAL_AREAS = "GET_POSTAL_AREAS",
  GET_POSTAL_AREAS_SUCCESS = "GET_POSTAL_AREAS_SUCCESS",
  GET_POSTAL_AREAS_FAIL = "GET_POSTAL_AREAS_FAIL",
  SAVE_POSTAL_AREA = "SAVE_POSTAL_AREA",
  SAVE_POSTAL_AREA_SUCCESS = "SAVE_POSTAL_AREA_SUCCESS",
  SAVE_POSTAL_AREA_FAIL = "SAVE_POSTAL_AREA_FAIL",
  UPDATE_POSTAL_AREA = "UPDATE_POSTAL_AREA",
  UPDATE_POSTAL_AREA_SUCCESS = "UPDATE_POSTAL_AREA_SUCCESS",
  UPDATE_POSTAL_AREA_FAIL = "UPDATE_POSTAL_AREA_FAIL",
  SET_POSTAL_AREA_DRAWER = "SET_POSTAL_AREA_DRAWER",
  DELETE_POSTAL_AREA = "DELETE_POSTAL_AREA",
  DELETE_POSTAL_AREA_SUCCESS = "DELETE_POSTAL_AREA_SUCCESS",
  DELETE_POSTAL_AREA_FAIL = "DELETE_POSTAL_AREA_FAIL",
}